import { render } from "./Toolbox.vue?vue&type=template&id=5976c856"
import script from "./Toolbox.vue?vue&type=script&lang=js"
export * from "./Toolbox.vue?vue&type=script&lang=js"

import "./Toolbox.vue?vue&type=style&index=0&id=5976c856&lang=scss"

import exportComponent from "/app/tmp/blackhall/V3/v2026.22.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__